module.exports = __webpack_public_path__ + "static/img/2_1_5.70a9f7f9.jpg";